<template>
  <div class="limiter">
    <div class="container-login">
      <div class="wrap-login">
          <div class="login-form validate-form">
              <span class="login-form-title">
                  Welcome
              </span>

              <div class="wrap-input validate-input" data-validate="Valid email is: a@email.c">
                  <input class="input" type="email" name="email" v-model="mail">
                  <span class="focus-input" data-placeholder="Email"></span>
              </div>

              <div class="wrap-input validate-input" data-validate="Enter password">
                  <span class="btn-show-pass">
                      <i class="zmdi zmdi-eye"></i>
                  </span>
                  <input class="input" type="password" name="pass" v-model="password">
                  <span class="focus-input" data-placeholder="Password"></span>
              </div>

              <div class="container-login-form-btn">
                  <div class="wrap-login-form-btn">
                      <button class="login-form-btn" @click="login" value="Login"> Login </button>
                  </div>
              </div>
              <div class="text-center">
                  <span class="txt1">
                      Don't have an account?
                  </span>
                  <a class="txt2" href="/#/register"> Sign Up </a>
              </div>
              <p class="txt1 warning" v-if="msg">{{ msg }}</p>
          </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript" src="../assets/js/login.js"></script>

<script>
import AuthService from '@/services/AuthService.js'

export default {
  data () {
    return {
      mail: '',
      password: '',
      msg: ''
    }
  },
  mounted () {
    $('.input').each(function(){
        $(this).on('blur', function(){
            if($(this).val().trim() != "") {
                $(this).addClass('has-val');
            }
            else {
                $(this).removeClass('has-val');
            }
        })
    })

    var input = $('.validate-input .input');

    $('.validate-form').on('submit',function(){
        var check = true;

        for(var i=0; i<input.length; i++) {
            if(validate(input[i]) == false){
                showValidate(input[i]);
                check=false;
            }
        }

        return check;
    });

    $('.validate-form .input').each(function(){
        $(this).focus(function(){
           hideValidate(this);
        });
    });

    function validate (input) {
        if($(input).attr('type') == 'email' || $(input).attr('name') == 'email') {
            if($(input).val().trim().match(/^([a-zA-Z0.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-z9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/) == null) {
                return false;
            }
        }
        else {
            if($(input).val().trim() == ''){
                return false;
            }
        }
    }

    function showValidate(input) {
        var thisAlert = $(input).parent();

        $(thisAlert).addClass('alert-validate');
    }

    function hideValidate(input) {
        var thisAlert = $(input).parent();

        $(thisAlert).removeClass('alert-validate');
    }

    var showPass = 0;
    $('.btn-show-pass').on('click', function(){
      if(showPass == 0)
      {
          $(this).next('input').attr('type','text');
          $(this).find('i').removeClass('zmdi-eye');
          $(this).find('i').addClass('zmdi-eye-off');
          showPass = 1;
      }
      else
      {
          $(this).next('input').attr('type','password');
          $(this).find('i').addClass('zmdi-eye');
          $(this).find('i').removeClass('zmdi-eye-off');
          showPass = 0;
      }
    });
  },
  methods: {
    async login () {
      try {
        const credentials = {
          mail: this.mail,
          password: this.password
        }
        const response = await AuthService.login(credentials)
        console.log(response)
        this.msg = response.msg
        const token = response.token
        const user = response.user
        this.$store.dispatch('login', { token, user })
        this.$router.push('/profile')
      } catch (error) {
        this.msg = error.response.data.msg
      }
    }
  }
}
</script>

<style lang="scss">

#login {
  p {
    color: #919191;

    span {
      color: #1d1d1d;
      cursor: pointer;
      font-weight: bold;
    }
  }

  input {
    border: none;
    border-bottom: 2px solid #919191;
    outline: none;
    color: #919191;
    width: 70%;
  }
}

#login > * {
  margin: 1em;
}

.button__green {
  background-color: rgb(76, 176, 80);
  padding: 0.5em 2em;
  border: solid 2px white;
  border-radius: 20px;
  color: white !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: none !important;
}

.zmdi-eye {
  background-size: 18px;
  background-image: url('../assets/eye.svg');
}
.zmdi-eye-off {
  background-size: 18px;
  background-image: url('../assets/hide.svg');
  transform: scale(0.9);
}
@media (min-width: 700px)
{
  .wrap-login {
    width: 450px;
  }
}
</style>
